import { render, staticRenderFns } from "./ConfirmPhoneStep.vue?vue&type=template&id=4e6715e4&scoped=true"
import script from "./ConfirmPhoneStep.vue?vue&type=script&lang=js"
export * from "./ConfirmPhoneStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6715e4",
  null
  
)

export default component.exports